// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects_container__26Aiw","body":"Projects_body__28Ohz"};